import msTeamPickerPaneStore from "../store/store";
import { mutatorAction } from "satcheljs";
import { IMsTeamWithScheduleInfo as IMsTeamWithScheduleInfo } from "sh-models";

export default mutatorAction('SET_MSTEAM_WITH_SCHEDULE_INFOS', function setMsTeamsWithScheduleInfos(msTeamsWithoutActiveSchedules: IMsTeamWithScheduleInfo[]) {
    msTeamPickerPaneStore().msTeamsWithoutActiveSchedules = msTeamsWithoutActiveSchedules;
});
